import React from 'react'
import Render from "components/Common/Render";
import InputField from "components/FormFields/InputField";
import PromotionPoints from "components/Home/PromotionPoints";
import { amountOptions } from "constants/amountOptions";
import { PlanActivationStatus } from "enum/common";
import useMixpanel from "hooks/useMixpanel";
import ReactSelect from "react-select";

interface ListYourBusinessPromotionDetailsProps {
  plan: BusinessPlanType;
  isGlobal: boolean;
  allowTopupUpdate: boolean;
  referralCode: string;
  getDefaultValue: () => any;
  setTopupAmount: (value: number) => void;
  setReferralCode: (value: string) => void;
  setShowTopupError: (value: boolean) => void;
  error:string
  setErrorMessage:(value:string) => void;
}

const ListYourBusinessPromotionDetails = ({
  plan,
  isGlobal,
  allowTopupUpdate,
  getDefaultValue,
  setTopupAmount,
  setReferralCode,
  referralCode,
  setShowTopupError,
  error,
  setErrorMessage
}: ListYourBusinessPromotionDetailsProps) => {
  const { trackEvent } = useMixpanel();
  const [disable,] = React.useState(referralCode)
  const styles = {
    inputStyle:
      "border border-black20 rounded-md mt-2 px-4 font-poppins md:flex-1 !mb-[0px]",
    formFieldContainer:
      "flex-1 flex md:flex-row flex-col md:gap-4 md:items-center",
    formLabel: "text-semibold  md:w-[250px]",
  };
 return (
    <>
      <p className={`text-navyBlue font-poppins tracking-wider text-base`}>
        Shoppers will earn 5% rewards for each purchase they make with you, up
        to $5
      </p>
      <PromotionPoints
        heading={"How it works:"}
        points={[
          "The rewards shoppers earn from you will be deducted from your rewards fund",
          "Your rewards fund will be automatically topped up when it falls below $25",
          "Only pay when customers have shopped with you!",
          "Cancel any time",
        ]}
      />
      <Render when={isGlobal}>
        <div className="flex flex-col md:items-center md:flex-row gap-4">
          <div className="gap-4 flex flex-col">
            <div className={styles.formFieldContainer}>
              <div className={`${styles.formLabel} mb-2 md:mb-0`}>
                Rewards Fund Top-Up Amount{" "}
              </div>
              <ReactSelect
                isDisabled={
                  !allowTopupUpdate &&
                  plan?.status === PlanActivationStatus.ACTIVATED
                }
                isSearchable={false}
                defaultValue={getDefaultValue()}
                autoFocus={false}
                placeholder="Select Amount"
                className="md:w-[280px]"
                isMulti={false}
                closeMenuOnSelect
                options={amountOptions}
                onChange={(selectedOption: any) => {
                  trackEvent("topup_amount_select", {
                    topUpAmount: selectedOption.value,
                  });
                  setTopupAmount(selectedOption.value);
                  setShowTopupError(false);
                }}
              />
            </div>
            <div className={styles.formFieldContainer}>
              <div className={styles.formLabel}>Referral Code <span className="gap-4 text-gray-400 text-sm  md:w-[250px]">(Optional)</span> </div>
              <InputField
                containerClass="!mb-0 md:w-[280px]"
                customClass={`${styles?.inputStyle} ${disable && 'text-opacity-40'}`}
                placeholder="XXXXXX"
                onChange={function (e: any): void {
                  setErrorMessage('')
                  setReferralCode(e.target.value);
                }}
                extras={{ disabled:disable }}
                value={referralCode}
                label={""}
                id={""}
                error={error}
              />
            </div>
          </div>
        </div>
      </Render>

      <PromotionPoints
        heading={"New Business Perks:"}
        subHeading={
          "Enjoy these limited-time perks, exclusive to new businesses!"
        }
        points={[
          'Highlighted under the prominent "New" filter on Discovery list and map for 1 month',
          "Prioritized placement on Discovery list and map for 2 weeks",
          "Announcement in activity feed scroll for 2 weeks",
        ]}
      />
    </>
  );
};

export default ListYourBusinessPromotionDetails;
